export function getApplicationComments(applicationId)
{
    return axios.get(route('api.manage.applications.applicationComments', { applicationId }))
        .then(response => response.data);
}

export function store(applicationId, data)
{
    return axios.post(route('api.manage.applications.applicationComments.store', {applicationId}) + '?include=mentionedUsers', data)
        .then(response => response.data);
}

export function update(commentId, data)
{
    return axios.patch(route('api.manage.applicationComments.destroy', {commentId}), data)
        .then(response => response.data);
}

export function destroy(commentId)
{
    return axios.delete(route('api.manage.applicationComments.destroy', {commentId}));
}
